import React, { Component, useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import language from "../../../libraries/label-lang";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import Api from "../../../libraries/api";
import QRCode from "qrcode.react";
import _ from "lodash";
import ReactToPrint from "react-to-print";
import { history } from "../../../shared/configure-store";
import { coverName } from '../inventories'

const color = "#419ad2";

const mapStateToProps = (state) => {
  return {
    toggle_set_lang: state.toggle_set_lang,
  };
};

export default connect(mapStateToProps)((props) => {
  const LANG = props.toggle_set_lang === "indo" ? language.id : language.en;
  const page_id = props.history.location.pathname.split("/")[3];

  const [isLoading, setLoading] = useState(false);
  const [data, setData, state, componentRef] = useState(null);

  let lang = {};
  if (props.toggle_set_lang === 'indo') {
    lang = language.id;
  } else {
    lang = language.en;
  }
  const text = lang;

  useEffect(() => {
    setLoading(true);
    Api.get(`/reservations/${page_id}`)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        //handle error in this project?
        setLoading(false);
      });

    let params = {
      reservationId: page_id,
    };

    Api.post('/reservation/label', params).then(resp => {

      let dataLababels = [];
      let item = [];
      if (resp.data.length > 0) {
        _.forEach(resp.data, function (v, i) {
          let row = i + 1;
          // console.log(row)

          let mod = row % 3;
          if (mod === 1) {
            item = [];
          }
          // console.log(mod)
          item.push(v);
          if (mod === 1) {
            dataLababels.push(item);
          }/*else if(mod === 1) {
                        dataLababels.push(item);
                    }*/
        });

        this.setState({
          labels: dataLababels,
          products: [],
          loadingSuccess: false,
        });
      }
    }).catch(err => {
      // this.setState({
      //     loadingSuccess: false,
      // });
      // this.showMessage(false, err.message);
    });
  }, []);

  const handleGo = (link) => {
    // console.log(link)
    props.history.push(link);
  };

  return (
    <div className="dashboard-detail">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">{LANG.label_dashboard}</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/reservations">{LANG.label_reservation}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Detail
          </li>
        </ol>
      </nav>
      <h2 className="text-uppercase ">detail pengiriman</h2>
      <div className="w-100 bg-white p-3 mt-2" style={{ borderRadius: 10 }}>
        {isLoading && (
          <div className="d-inline-flex justify-content-center align-items-center w-100 p-3">
            <CircularProgress />
          </div>
        )}
        {data && (
          <>
            <div
              className="d-inline-flex justify-content-between align-items-center w-100 pb-2 mb-2"
              style={{ borderBottom: `1px solid #eee` }}
            >
              <div style={{ fontSize: 14, color }}>{data.nota}</div>
              <div className="text-right">
                <div style={{ fontSize: 18, color, fontWeight: "bold" }}>
                  {/* item.status */}
                  {coverName(data.status, props.toggle_set_lang === 'indo')}
                </div>
                <div style={{ fontSize: 10 }}>
                  {/* item.updated_at */}
                  Perubahan Status Terakhir: {data.lastUpdate}
                </div>
              </div>
            </div>
            <h2>{data.companyName}</h2>
            <div style={{ fontSize: 10 }}>
              {data.contactName} {data.contactEmail} - {data.contactPhoneCell}
            </div>

            <BoxTime {...{ data }} />

            <br />
            {data.SKU.map((product, i) => (
              <BoxDetail key={i} {...{ product }} />
            ))}

            <div className="d-inline-flex mt-2">
              {/*<div className='col-md-12 col-lg-12'>*/}
              {/*    /!*<PrintLabelsNote lang={props.toggle_set_lang} data={state.data} />*!/*/}
              {/*    <PrintLabelsNote*/}
              {/*        trigger={() =>  <Button*/}
              {/*            variant='contained'*/}
              {/*            className='btn-link'*/}
              {/*        ><i className="fas fa-print mr-2" > </i>*/}
              {/*            {text.button_print}*/}
              {/*        </Button>}*/}
              {/*        content={() => this.componentRef}*/}
              {/*    />*/}
              {/*</div>*/}
              <Button
                variant="contained"
                color="secondary"
                className="mr-3"
                onClick={() => handleGo('/reservation-note/' + page_id)}
              // onClick={this.handleDelete}
              //   disabled={this.state.loadingButton && "disabled"}
              >
                Cetak Surat Jalan
                {/* {this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>} */}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleGo('/reservation-success/' + page_id)}
              //   onClick={this.handleDelete}
              //   disabled={this.state.loadingButton && "disabled"}
              >
                Cetak IKU
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
});

const BoxTime = ({ data }) => (
  <div
    className="p-2 my-2 d-inline-flex"
    style={{
      borderRadius: 10,
      fontSize: 14,
      background: "#f8f8f8",
    }}
  >
    <div>Tanggal Pengiriman : {data.reservationDate}</div>
  </div>
);

const BoxDetail = ({ product }) => (
  <div
    className="p-2 my-2 d-inline-flex flex-column table-responsive"
    style={{
      borderRadius: 10,
      border: `1px solid #d8d8d8`,
    }}
  >
    <h2 className="m-2">SKU- {product.skuNumber}</h2>
    <table className="table table-borderless">
      <thead style={{ borderBottom: `2px solid #d8d8d8`, fontSize: 12 }}>
        <tr>
          <th scope="col">IKU</th>
          <th scope="col">Nama Produk</th>
          <th scope="col">Berat</th>
          <th scope="col">Penyimpanan</th>
          <th scope="col">Status</th>
          <th scope="col">Tanggal Penyimpanan</th>
          <th scope="col">Locker Size</th>
        </tr>
      </thead>
      <tbody style={{ fontSize: 14 }}>
        {product.iku.map((item, i) => (
          <tr key={i}>
            <td >{item.ikuId.toUpperCase()}</td>
            <td >{item.productName.toUpperCase()}</td>
            <td>{item.weight.toUpperCase()}</td>
            <td>{item.warehouse.toUpperCase()}</td>
            <td>{coverName(item.status, 'indo').toUpperCase()}</td>
            <td>{item.date.toUpperCase()}</td>
            <td>{item.lockerSize.toUpperCase()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

{
  class PrintLabelsNote extends Component {
    constructor(props) {

      super(props);

      this.state = {
        loadingNote: false,
        email: '',
        data: this.props.data,
        lang: this.props.lang,
        productsNote: []//this.props.data.products ? this.props.data.products : [],
      };
    }

    componentDidMount() {
      document.title = 'Fresh Factory - Berhasil';

    }

    render() {

      let lang = {};
      if (this.state.lang === 'indo') {
        lang = language.id;
      } else {
        lang = language.en;
      }
      const text = lang;

      return (
        <table width="100%" cellPadding='3'>
          <thead>
            <tr>
              <th colSpan={5}>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                &nbsp;
                    </th>
            </tr>
            <tr>
              <table width="700px" style={{ margin: 'auto' }}>
                <thead>
                  <tr>
                    <th className="text-left">
                      <label className='p-10 label-note text-left'>{text.label_company}</label>
                      <p className='p-12 mb-0'><strong>{this.state.data.company_name}</strong></p>
                      <p className='p-12 text-grey'>{this.state.data.primary_address}, {this.state.data.primary_city}, {this.state.data.primary_state}</p>
                    </th>
                    <th style={{ textAlign: 'right' }} >
                      {this.state.data.nota &&
                        <QRCode
                          size={100}
                          value={this.state.data.nota} />
                      }
                      <small className='p-8 text-grey d-block'>{this.state.data.nota}</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-left">
                    <td width="50%">
                      <label className='p-10 label-note'>{text.label_warehouse_place}</label>
                      <p className='p-12'><strong>{this.state.data.warehouse}</strong></p>
                    </td>
                    <td width="50%">
                      <label className='p-10 label-note'>{text.label_name_contact}</label>
                      <p className='mb-0 p-12'><strong>{this.state.data.contact_name}</strong></p>
                      <p className='p-12 text-grey'>{this.state.data.contact_email}/{this.state.data.contact_phone_office}/{this.state.data.contact_phone_cell}</p>
                    </td>
                  </tr>
                  <tr className="text-left">
                    <td colSpan='2' width='100%'>
                      <div className='card-cream mt-0'>
                        <div className='row mx-auto py-4 align-items-center'>
                          <div className='col-11 text-left p-10 color-brown-grey'>
                            <label className='mb-0'><i className='far fa-map pr-2'> </i> {text.label_warehouse_address}</label>
                            <p className='p-12 color-gunmetal mb-0'>{this.state.data.warehouse_address1 + ' ' + this.state.data.warehouse_address2 + ', ' + this.state.data.warehouse_city + ', ' + this.state.data.warehouse_state}</p>
                          </div>
                          <div className='col-1'>
                            <i className='fas fa-map-marker-alt color-reddish'> </i>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="text-left">
                    <td colSpan='3' width='100%'>
                      <div className='card-nota d-block'>
                        <table width='100%'>
                          <tbody>
                            <tr >
                              <th>
                                <h3 className='p-18'>{text.label_time}</h3>
                                <p className='p-12'>{this.state.data.reservation_date}</p>
                                <h3 className='p-18'>{text.reservation_product}</h3>
                              </th>
                              <th></th>
                              <th></th>
                            </tr>
                            <tr>
                              <td><p className='p-10 mb-0'>{text.label_product}</p></td>
                              <td><p className='p-10 mb-0'>{text.label_quantity}</p></td>
                              <td><p className='p-10 mb-0'>{text.label_sku}</p></td>
                            </tr>
                            {
                              this.state.productsNote.length > 0 &&
                              this.state.productsNote.map(function (item) {
                                return (<tr key={item.sku_number}>
                                  <td width="33%">
                                    <p className='p-12'>{item.name}</p>
                                  </td>
                                  <td width="33%">
                                    <p className='p-12'>{item.quantity}</p>
                                  </td>
                                  <td width="33%">
                                    <p className='p-12'>{item.sku_number}</p>
                                  </td>
                                </tr>
                                )
                              })
                            }
                          </tbody>

                        </table>

                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan='2' width='100%'>
                      <div className='card-cream p-3'>
                        <p className='p-10 color-gunmetal mb-0'>*{text.note_text}</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </tr>
          </tbody>
        </table>
      )
    }
  }
}
